import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Rocket } from "lucide-react";
import logoFreelaDash from "@/assets/logo-freeladash.png";

export function LandingHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrolled(currentScrollY > 20);
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <AnimatePresence>
      <motion.header
        initial={{ y: 0 }}
        animate={{ y: isVisible ? 0 : -100 }}
        transition={{ duration: 0.3 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? "bg-white/95 backdrop-blur-xl border-b border-border shadow-sm"
            : "bg-transparent"
        }`}
      >
        <div className="container mx-auto flex h-16 items-center justify-between px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2 group">
            <img
              src={logoFreelaDash}
              alt="FreelaDash - Gestão para Freelancers"
              className="h-8 w-8 rounded-lg object-contain sm:h-9 sm:w-9 transition-transform group-hover:scale-110"
              width={36}
              height={36}
            />
            <span
              className="font-display text-xl font-bold tracking-wide text-primary sm:text-2xl"
              style={{ WebkitTextStroke: "0.5px currentColor" }}
            >
              FREELADASH
            </span>
          </Link>

          <nav className="flex items-center gap-3 sm:gap-4">
            <Link to="/login">
              <Button
                variant="ghost"
                size="sm"
                className="text-muted-foreground hover:text-foreground hover:bg-muted px-3"
              >
                Entrar
              </Button>
            </Link>
            <Link to="/signup">
              <Button
                size="sm"
                className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-md gap-1.5"
              >
                <Rocket className="h-4 w-4" />
                <span className="hidden sm:inline">Testar Grátis</span>
                <span className="sm:hidden">Testar</span>
              </Button>
            </Link>
          </nav>
        </div>
      </motion.header>
    </AnimatePresence>
  );
}
